export default "__VITE_ASSET__aVexdB8i__"